var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",staticClass:"credential card-content"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.findings))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }